import React, { useEffect, useMemo, useState } from 'react';
import { Watermark } from 'antd';
import authService from '../services/authService';

const timestampFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Ulaanbaatar',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZoneName: 'short',
});

// A visible sharing deterrent; this does not prevent screen capture.
const StudentWatermark: React.FC<{
  children: React.ReactNode;
  style?: React.CSSProperties;
  color?: string;
}> = ({ children, style, color = 'rgba(128, 128, 128, 0.12)' }) => {
  const user = authService.getCurrentUser();
  const studentName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim()
    || user?.username || 'Student';
  const [timestamp, setTimestamp] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setTimestamp(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  const content = useMemo(() => [
    'ICER',
    studentName,
    timestampFormatter.format(timestamp),
  ], [studentName, timestamp]);

  return (
    <div style={{ ...style, position: 'relative', overflow: 'hidden', isolation: 'isolate' }}>
      {children}
      <Watermark
        content={content}
        font={{ color, fontSize: 12 }}
        gap={[60, 80]}
        rotate={-22}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 9,
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default StudentWatermark;
